import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-314b01e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  width: "16",
  height: "30",
  viewBox: "0 0 16 30",
  fill: "none"
}
const _hoisted_2 = ["fill"]


export default /*#__PURE__*/_defineComponent({
  __name: 'ArrowButton',
  props: {
    direction: { default: "left" },
    customClass: {},
    isDisabled: { type: Boolean, default: false },
    fillColor: { default: "#606266" },
    fillColorDisabled: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function clickHandler() {
  emit("click");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["frisbuy-arrow-button", [
      `frisbuy-arrow-button--${props.direction}`,
      _ctx.customClass,
      { '--disabled': _ctx.isDisabled },
    ]]),
    onClick: clickHandler
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, [
      _createElementVNode("path", {
        d: "M13.645 0.820039L0.71502 14.14C0.480853 14.3742 0.36377 14.6542 0.36377 14.98C0.36377 15.3059 0.480853 15.5988 0.71502 15.8588L13.645 29.1788C13.8792 29.3871 14.1525 29.4913 14.465 29.4913C14.7775 29.4913 15.0509 29.3742 15.285 29.14C15.5192 28.9059 15.6363 28.6325 15.6363 28.32C15.6363 28.0075 15.5192 27.7342 15.285 27.5L3.09752 15L15.285 2.50004C15.5192 2.26587 15.6363 1.99254 15.6363 1.68004C15.6363 1.36754 15.5192 1.09421 15.285 0.860039C15.0509 0.625873 14.7775 0.508789 14.465 0.508789C14.1525 0.508789 13.8792 0.612956 13.645 0.821289V0.820039Z",
        fill: _ctx.isDisabled && _ctx.fillColorDisabled ? _ctx.fillColorDisabled : _ctx.fillColor
      }, null, 8, _hoisted_2)
    ]))
  ], 2))
}
}

})